// Обёртка над Telegram.WebApp с безопасными заглушками для обычного браузера
// (локальная разработка и страница получателя подарка, открытая не в Telegram).

type Haptic = 'light' | 'medium' | 'heavy' | 'rigid' | 'soft';

interface WebApp {
  initData: string;
  initDataUnsafe: { user?: { id: number; first_name?: string }; start_param?: string };
  version: string;
  platform: string;
  ready(): void;
  expand(): void;
  close(): void;
  isVersionAtLeast(v: string): boolean;
  setHeaderColor(c: string): void;
  setBackgroundColor(c: string): void;
  disableVerticalSwipes?(): void;
  openLink(url: string, opts?: { try_instant_view?: boolean }): void;
  openTelegramLink(url: string): void;
  requestContact?(cb: (ok: boolean, res?: { responseUnsafe?: { contact?: { phone_number?: string } } }) => void): void;
  BackButton: { show(): void; hide(): void; onClick(cb: () => void): void; offClick(cb: () => void): void };
  HapticFeedback?: { impactOccurred(s: Haptic): void; notificationOccurred(t: 'success' | 'error' | 'warning'): void; selectionChanged(): void };
}

const w = (globalThis as any).Telegram?.WebApp as WebApp | undefined;
/** true, если приложение открыто внутри Telegram (есть подписанные данные запуска). */
export const inTelegram = Boolean(w && w.initData);

export function initTelegram() {
  if (!w) return;
  w.ready();
  w.expand();
  try {
    w.setHeaderColor('#FAFBF6');
    w.setBackgroundColor('#FAFBF6');
    // Свайп вниз не должен закрывать приложение посреди свайпов карточек.
    if (w.isVersionAtLeast('7.7')) w.disableVerticalSwipes?.();
  } catch {
    /* старый клиент */
  }
}

export const initData = () => w?.initData ?? '';
export const startParam = () => w?.initDataUnsafe.start_param ?? null;
export const firstName = () => w?.initDataUnsafe.user?.first_name ?? null;

export function onBack(cb: () => void, visible: boolean) {
  if (!w) return () => {};
  if (visible) w.BackButton.show();
  else w.BackButton.hide();
  w.BackButton.onClick(cb);
  return () => w.BackButton.offClick(cb);
}

/** Закрыть приложение: клиент окажется в чате с ботом. */
export function closeApp() {
  if (w && inTelegram) w.close();
}

export function openLink(url: string) {
  if (w && inTelegram) w.openLink(url);
  else window.open(url, '_blank', 'noopener');
}

export function shareToTelegram(url: string, text: string) {
  const share = `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(text)}`;
  if (w && inTelegram) w.openTelegramLink(share);
  else window.open(share, '_blank', 'noopener');
}

/** Номер из Telegram одним нажатием (Bot API 6.9+). */
export function requestPhone(): Promise<string | null> {
  return new Promise((resolve) => {
    if (!w?.requestContact || !w.isVersionAtLeast('6.9')) return resolve(null);
    w.requestContact((ok, res) => resolve(ok ? res?.responseUnsafe?.contact?.phone_number ?? null : null));
  });
}

export const haptic = {
  tap: () => w?.HapticFeedback?.impactOccurred('light'),
  pick: () => w?.HapticFeedback?.selectionChanged(),
  ok: () => w?.HapticFeedback?.notificationOccurred('success'),
  err: () => w?.HapticFeedback?.notificationOccurred('error'),
};
